'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSequenceFromDNA = exports.generate = undefined;

var _ntseq = require('ntseq');

var _ntseq2 = _interopRequireDefault(_ntseq);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generate = exports.generate = function generate() {
  var nucleotides = ['A', 'T', 'C', 'G'];
  var length = Math.round(Math.random() * 90) + 10;

  var s = [];
  for (var i = 0; i < length; i++) {
    s.push(nucleotides[Math.floor(Math.random() * nucleotides.length)]);
  }

  return {
    id: 'WD' + new Date().getTime() + length,
    name: 'Sequence ' + length,
    dna: s.join('')
  };
};

var createSequenceFromDNA = exports.createSequenceFromDNA = function createSequenceFromDNA(dna) {
  return new _ntseq2.default.Seq().read(dna);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/seq-utils/dist/index.js
// module id = 193
// module chunks = 0